import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=2574139c&scoped=true&"
var script = {}
import style0 from "./Create.vue?vue&type=style&index=0&id=2574139c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574139c",
  null
  
)

export default component.exports